import Spinners from "components/Shared/Spinners"
import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Container } from "reactstrap"
import { getJobTitlesList } from "store/actions/commonAction"
import {
  getInterviewQuestions,
  submitInterviewAssessment,
} from "store/actions/interviewsAction"
import { showAlert } from "store/reducers/alertReducer"

const InterViewStart = ({ selectedItem, toggle, getAllData }) => {
  const { loadingInterviewQ, interviewQuestions, totalAllowTime, isLoading } =
    useSelector(state => state.Interviews)
  const { jobTitlesList } = useSelector(state => state.Common)

  const dispatch = useDispatch()

  const [grade, setGrade] = useState(0) // Initialize grade to 0
  const [timeLeft, setTimeLeft] = useState(totalAllowTime || 120) // 2 minutes in seconds
  const [activeButtons, setActiveButtons] = useState({}) // Track selected options
  const [textInputs, setTextInputs] = useState({}) // Track text inputs
  const [jobNominated, setJobNominated] = useState(null)
  const [proposedPosition, setProposedPosition] = useState(null)
  const [suitableForJob, setSuitableForJob] = useState(null) // Track suitability for job
  const [leadershipPosition, setLeadershipPosition] = useState(null)
  const [reason, setReason] = useState(null)
  const [review, setReview] = useState("") // Track review
  const [isNominatedForLeadership, setIsNominatedForLeadership] =
    useState(false) // Track leadership nomination
  const [nominatedJob, setNominatedJob] = useState(null) // Track nominated job

  useEffect(() => {
    console.log(timeLeft)
    getQAData()
    getAllJobTitles()
  }, [])

  const getQAData = () => {
    dispatch(getInterviewQuestions())
  }

  const getAllJobTitles = () => {
    dispatch(getJobTitlesList())
  }

  // Countdown timer
  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeLeft(timeLeft - 1)
    }, 1000)
    return () => clearInterval(timerId)
  }, [timeLeft])

  // Handle button click for options
  // Handle button click for options
  const handleButtonClick = (questionId, optionId, score) => {
    setActiveButtons(prev => {
      const newActiveButtons = { ...prev, [questionId]: optionId }

      // Calculate score using the updated buttons state
      const totalScore = interviewQuestions
        .flatMap(category => category.questions)
        .reduce((acc, question) => {
          const selectedOptionId = newActiveButtons[question.id]
          if (selectedOptionId) {
            const selectedOption = question.options.find(
              opt => opt.id === selectedOptionId
            )
            return acc + (selectedOption ? selectedOption.score : 0)
          }
          return acc
        }, 0)

      // Update score with the new calculated value
      setGrade(totalScore)

      return newActiveButtons
    })
  }

  // Handle text input change
  const handleInputChange = (questionId, value) => {
    setTextInputs(prev => ({ ...prev, [questionId]: value }))
  }

  // Format time for display
  const formatTime = seconds => {
    const isNegative = seconds < 0 // Check if time is negative
    const absoluteSeconds = Math.abs(seconds) // Work with absolute value for calculation
    const mins = Math.floor(absoluteSeconds / 60)
    const secs = absoluteSeconds % 60
    return `${isNegative ? "-" : ""}${mins}:${secs < 10 ? "0" : ""}${secs}`
  }

  // Generate final data structure
  const generateFinalData = () => {
    const assessments = interviewQuestions.map(category => ({
      category_id: category.id,
      questions: category.questions.map(question => ({
        question_id: question.id,
        option_id: activeButtons[question.id] || null,
        total_score: question.total_score,
        obtained_score: activeButtons[question.id]
          ? question.options.find(opt => opt.id === activeButtons[question.id])
              .score
          : 0,
      })),
    }))

    return {
      user_id: selectedItem?.user?.id, // Replace with actual user ID
      job_application_id: selectedItem?.job_application_id, // Replace with actual job application ID
      interview_schedule_id: selectedItem?.interview_schedule?.id, // Replace with actual interview schedule ID
      time_taken: timeLeft, // Time taken in seconds
      assessments,
      is_candidate_suitable_for_job: suitableForJob === "Yes",
      review,
      review_type: reason,
      is_candidate_nominated_for_leadership: leadershipPosition === "Yes",
      nominated_job: null, // FOR NOW STATIC
      job_title_id: proposedPosition,
    }
  }

  // Handle end of interview
  const handleEndInterview = () => {
    const finalData = generateFinalData()
    // console.log("Final Data:", finalData)
    console.log(finalData)
    const { uuid } = selectedItem

    const updatedPayload = {
      uuid,
      payload: finalData,
    }

    dispatch(submitInterviewAssessment(updatedPayload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          toggle()
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div className="">
      {loadingInterviewQ ? (
        <Spinners />
      ) : (
        <Container fluid>
          <div className="interview_container">
            <div className="left">
              <div className={`timer ${timeLeft > 0 ? "" : "time_left"}`}>
                {formatTime(timeLeft)}
              </div>
              <div className="final_grade">
                <h6>Final Grade</h6>
                <h5 className={`${grade >= 60 ? "text-success" : ""}`}>
                  {grade} <span>/100</span>
                </h5>
              </div>
              {/* Candidate info and other UI elements */}
            </div>
            <div className="right">
              <div className="questions_container">
                {interviewQuestions.map((category, catIndex) => (
                  <div className="q_single" key={catIndex}>
                    <h3 className="title">{category.qn_category}</h3>
                    {category.questions.map((question, qIndex) => (
                      <div className="question" key={question.id}>
                        <div className={`q_left ${question.type}`}>
                          <h6>{question.question}</h6>
                        </div>
                        <div className="q_right">
                          {question.type === "option" ? (
                            <div className="button_group">
                              {question.options.map(option => (
                                <button
                                  key={option.id}
                                  className={`theme_btn ${
                                    activeButtons[question.id] === option.id
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    handleButtonClick(
                                      question.id,
                                      option.id,
                                      option.score
                                    )
                                  }
                                >
                                  {option.option}
                                </button>
                              ))}
                            </div>
                          ) : (
                            ""
                            // <textarea
                            //   value={textInputs[question.id] || ""}
                            //   onChange={e =>
                            //     handleInputChange(question.id, e.target.value)
                            //   }
                            // />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
                <div className="q_single">
                  <h3 className="title">General recommendation</h3>
                  {/* Is the candidate suitable for the job */}
                  <div className="question">
                    <div className="q_left">
                      <h6>Is the candidate suitable for the job?</h6>
                    </div>
                    <div className="q_right">
                      <div className="button_group">
                        {["Yes", "No"].map(option => (
                          <button
                            key={option}
                            className={`theme_btn ${
                              suitableForJob === option ? "active" : ""
                            }`}
                            onClick={() => {
                              setSuitableForJob(option)
                              setReview("")
                            }}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Reason - Show only when "No" is selected */}
                  {suitableForJob === "No" && (
                    <div className="question">
                      <div className="q_left">
                        <h6>Reason</h6>
                      </div>
                      <div className="q_right">
                        <div className="button_group">
                          {[
                            "Other",
                            "Nationality does not match",
                            "Age does not match",
                          ].map(option => (
                            <button
                              key={option}
                              className={`theme_btn ${
                                reason === option ? "active" : ""
                              }`}
                              onClick={() => setReason(option)}
                            >
                              {option}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Job nominated - Show only when "Yes" is selected */}
                  {suitableForJob === "Yes" && (
                    <div className="question">
                      <div className="q_left">
                        <h6>Job nominated</h6>
                      </div>
                      <div className="q_right">
                        <div className="button_group">
                          {[
                            "Station Pier",
                            "Entrance gates and waiting area",
                          ].map(option => (
                            <button
                              key={option}
                              className={`theme_btn ${
                                jobNominated === option ? "active" : ""
                              }`}
                              onClick={() => setJobNominated(option)}
                            >
                              {option}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Is he nominated for a leadership position? - Show only when "Yes" is selected */}
                  {suitableForJob === "Yes" && (
                    <div className="question">
                      <div className="q_left">
                        <h6>Is he nominated for a leadership position?</h6>
                      </div>
                      <div className="q_right">
                        <div className="button_group">
                          {["No", "Yes"].map(option => (
                            <button
                              key={option}
                              className={`theme_btn ${
                                leadershipPosition === option ? "active" : ""
                              }`}
                              onClick={() => setLeadershipPosition(option)}
                            >
                              {option}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Proposed position - Show only when "Job nominated" is "Entrance gates and waiting area" */}
                  {jobNominated === "Entrance gates and waiting area" && (
                    <div className="question">
                      <div className="q_left">
                        <h6>Proposed position</h6>
                      </div>
                      <div className="q_right">
                        <select
                          value={proposedPosition || ""}
                          onChange={e => setProposedPosition(e.target.value)}
                        >
                          <option value="" disabled>
                            Select an option
                          </option>
                          {jobTitlesList?.map(item => (
                            <option value={item?.id} key={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  {/* Reviews */}
                  {(suitableForJob === "Yes" ||
                    (suitableForJob === "No" && reason === "Other")) && (
                    <div className="question">
                      <div className="q_left">
                        <h6>Reviews</h6>
                      </div>
                      <div className="q_right">
                        <textarea
                          value={review}
                          onChange={e => setReview(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="action_btn">
                <button
                  className="theme_btn"
                  style={{ marginRight: "8px" }}
                  disabled={isLoading}
                  onClick={toggle}
                >
                  Cancel
                </button>
                <button
                  className="theme_btn fill"
                  onClick={handleEndInterview}
                  disabled={isLoading}
                >
                  End of Interview
                </button>
              </div>
            </div>
          </div>
        </Container>
      )}
    </div>
  )
}

export default InterViewStart
